import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { KeycloakService } from 'keycloak-angular';
import { kebabCase } from 'lodash-es';
import type { Observable } from 'rxjs';
import { AppService } from 'src/app/app.service';
import { Api } from 'src/app/core/api/Api';
import {
  ENVIRONMENTS_PREFIX,
  EnvironmentService,
} from 'src/app/core/environment/environment.service';
import type { DnsCheck, Features, KWSConfig } from './kws.model';

@Injectable({
  providedIn: 'root',
})
export class KwsService {
  constructor(
    private http: HttpClient,
    private appService: AppService,
    private envSerice: EnvironmentService,
    private authService: KeycloakService,
  ) {}

  fetchDns(): Observable<DnsCheck> {
    return this.http.get<DnsCheck>(Api.KWSDns);
  }

  fetchKWS(): Observable<KWSConfig> {
    return this.http.get(Api.KWS) as Observable<KWSConfig>;
  }

  changeKWSSettings(configuration: KWSConfig | { features: Features }) {
    return this.http.put(Api.KWS, configuration);
  }

  disableKWS() {
    return this.http.put(Api.DisableWS, {
      active: false,
    });
  }

  enableKWS() {
    return this.http.put(Api.DisableWS, {
      active: true,
    });
  }

  openDashboard() {
    this.authService.getToken().then((token) => {
      const link = this.getDashboardLink(token);
      window.open(link);
    });
  }

  private getDashboardLink(token: string) {
    const tenant = kebabCase(this.appService.tenant);
    const envPrefix = ENVIRONMENTS_PREFIX[this.envSerice.env];
    return `https://dashboard${envPrefix}.meinkontowechsel.de?tenant=${tenant}&token=${token}`;
  }
}
